import React from 'react';
import {i18n} from '@netx/core/i18n';

import moment from '@netx/core/lib/netx-moment';

import {styled} from '@netx/core-components/Theme';

import {
	getInputFormObject,
	FormType,
	InputForm,
	LegacyFormDateField,
} from '@netx/core-components/Form';

const AssetExpirationFormRoot = styled('div', {
	name: 'AssetExpirationForm',
	slot: 'Root',
})(({theme}) => ({}));

type FormValues = {
	expirationDate: string | null;
};

const validator = async (value: string): Promise<true | Error> => {
	return true;
};

export interface AssetExpirationFormProps {
	form: FormType<FormValues>;
	inputForm?: InputForm<FormValues>;
}

export const AssetExpirationForm = ({
	form,
	inputForm,
	...props
}: AssetExpirationFormProps) => {
	if (!inputForm) inputForm = getInputFormObject(form);

	return (
		<AssetExpirationFormRoot>
			<LegacyFormDateField
				fullWidth
				label={i18n.t('i18n.expirationDate')}
				name="expirationDate"
				id="expirationDate"
				minDate={moment().local().add(1, 'days').format('YYYY-MM-DD')}
				error={form.errors.expirationDate}
				required={true}
				value={form.values.expirationDate}
				form={inputForm}
				formFieldOptions={{
					validator,
				}}
			/>
		</AssetExpirationFormRoot>
	);
};

export default AssetExpirationForm;
